export const Label = ({
  label,
  htmlFor,
  className,
}: {
  label: string;
  htmlFor: string;
  className?: string;
}) => {
  return (
    <label
      htmlFor={htmlFor}
      className={`text-sm font-medium text-gray-700 dark:text-gray-200 ${className}`}>
      {label}
    </label>
  );
};
